import { useTranslation } from 'react-i18next';
import { API_ORIGIN } from '../../lib/api';

/**
 * Branded Google + Apple buttons. Each hits the backend OAuth start
 * endpoint (`/auth/google` or `/auth/apple`) on the API origin
 * (`api.plyez.com` in production). These routes are excluded from the
 * Nest global `/api` prefix so the IdP redirect lands cleanly.
 */
export function OAuthButtons({ context }: { context: 'login' | 'signup' }) {
  const { t } = useTranslation();
  const verbKey = context === 'signup' ? 'auth.continueWith' : 'auth.continueWith';

  return (
    <div className="space-y-2.5">
      <a
        href={`${API_ORIGIN}/auth/google`}
        className="w-full inline-flex items-center justify-center gap-3 h-11 rounded-lg border border-border bg-card text-foreground text-sm font-medium hover:bg-muted transition-colors"
      >
        <GoogleIcon /> {t(verbKey, { provider: 'Google' })}
      </a>
      <a
        href={`${API_ORIGIN}/auth/apple`}
        className="w-full inline-flex items-center justify-center gap-3 h-11 rounded-lg bg-foreground text-background text-sm font-medium hover:bg-foreground/90 transition-colors"
      >
        <AppleIcon /> {t(verbKey, { provider: 'Apple' })}
      </a>
    </div>
  );
}

function GoogleIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
      <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.76h3.56c2.08-1.92 3.28-4.74 3.28-8.09Z"/>
      <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.56-2.76c-.98.66-2.24 1.06-3.72 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A11 11 0 0 0 12 23Z"/>
      <path fill="#FBBC05" d="M5.84 14.11A6.6 6.6 0 0 1 5.5 12c0-.73.13-1.44.34-2.11V7.05H2.18a11 11 0 0 0 0 9.9l3.66-2.84Z"/>
      <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1A11 11 0 0 0 2.18 7.05l3.66 2.84C6.71 7.3 9.14 5.38 12 5.38Z"/>
    </svg>
  );
}

function AppleIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true" fill="currentColor">
      <path d="M16.365 1.43c0 1.14-.473 2.21-1.232 3.012-.831.901-2.214 1.59-3.343 1.5-.14-1.115.422-2.281 1.143-3.04.83-.88 2.262-1.557 3.432-1.472Zm4.097 17.012c-.638 1.42-.95 2.054-1.768 3.31-1.135 1.74-2.735 3.908-4.712 3.93-1.758.02-2.21-1.146-4.597-1.13-2.388.013-2.884 1.149-4.642 1.13-1.977-.02-3.494-1.97-4.628-3.71-3.176-4.87-3.51-10.59-1.55-13.63 1.39-2.16 3.589-3.42 5.658-3.42 2.106 0 3.432 1.154 5.176 1.154 1.693 0 2.722-1.158 5.16-1.158 1.843 0 3.795 1 5.184 2.733-4.553 2.494-3.813 8.99.72 10.79Z"/>
    </svg>
  );
}
